"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var roster_1 = require("../../messages/roster");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var ControllerClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(ControllerClient, _base_1$default);

  function ControllerClient(options) {
    var _this;

    _classCallCheck(this, ControllerClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ControllerClient).call(this, options));
    _this.acceptGuestRoster = methods_factory_1.AcceptMessageFactory(roster_1.GuestRoster, 1);
    _this.acceptStaffRoster = methods_factory_1.AcceptMessageFactory(roster_1.StaffRoster, 1);
    _this.unacceptGuestRoster = methods_factory_1.UnacceptMessageFactory(roster_1.GuestRoster);
    _this.unacceptStaffRoster = methods_factory_1.UnacceptMessageFactory(roster_1.StaffRoster);
    _this.setGuestRoster = methods_factory_1.SendMessageFactory();
    _this.setStaffRoster = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return ControllerClient;
}(base_1.default);

exports.ControllerClient = ControllerClient;
exports.default = ControllerClient;